module.exports = __webpack_public_path__ + "media/images/icons/outlined/check-square-a69df8ecdb9d18551ccd6cde6cc6d7a5.svg";